import { getHighlightColumnSpans } from '@utils/event-report/get-highlight-column-spans';
import { getHighlightColumnSpansBesideCard } from '@utils/event-report/get-highlight-column-spans-beside-card';

export const HighlightSectionSkeletonCards = ({
  cardCount = 6,
  isBesideLeadingCard = false,
}: {
  cardCount?: number;
  isBesideLeadingCard?: boolean;
}) =>
  Array.from(
    (isBesideLeadingCard ? getHighlightColumnSpansBesideCard : getHighlightColumnSpans)(cardCount),
    (columnSpan, i) => (
      <div
        key={`highlight-card-${i}`}
        className={`p-4 basis-32 shrink-0 md:w-full ${columnSpan} bg-surface-secondary rounded-lg animate-pulse min-h-[146px] md:min-h-0`}>
        <div className='flex flex-col gap-2'>
          <div className='h-4 bg-tertiary w-20 rounded-sm'></div>
          <div className='h-6 bg-tertiary w-24 rounded-sm'></div>
          <div className='h-3 bg-tertiary w-16 rounded-sm'></div>
        </div>
      </div>
    )
  );
